import { __decorate } from "tslib";
import { Component } from 'decorators';
import template from './AddContentView.html';
import { BuilderFeatures } from 'modules/application/detail/portal-submodule-builder/templates/builder/BuilderFeatures';
import { Add, AddWithChatState, AddWithChatStateUserInput, } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/content/components/addContent/addContent.dispatcher';
import { ActionFeatures } from '../../../actions/ActionFeatures';
let AddContentComponent = class AddContentComponent {
    $onInit() {
        this.init();
    }
    async init() {
        this.isBuilderSurveyActionEnabled = await ActionFeatures.isActionSurveyEnabled();
        this.isBuilderStickerDisabled = await BuilderFeatures.isBuilderStickerDisabled();
    }
    $dispatch($action) {
        if (this.onAction) {
            this.onAction({ $action });
        }
        else {
            throw new Error('onAction callback is not implemented');
        }
    }
    add({ type }) {
        const addAction = new Add({
            type,
            index: this.position,
        });
        this.$dispatch(addAction);
    }
    addWithChatState({ type }) {
        const addWithChatStateAction = new AddWithChatState({
            type,
            index: this.position,
        });
        this.$dispatch(addWithChatStateAction);
    }
    addWithChatStateUserInput({ type }) {
        const addWithChatStateUserInputAction = new AddWithChatStateUserInput({
            type,
            index: this.position,
        });
        this.$dispatch(addWithChatStateUserInputAction);
    }
};
AddContentComponent = __decorate([
    Component({
        template,
        bindings: {
            position: '<?',
            showText: '<?',
            onAction: '&?',
        },
    })
], AddContentComponent);
export { AddContentComponent };
